// Serviços de Tipos de Serviços usando Axios compartilhado (baseURL vem de REACT_APP_API_BASE)
import api from '../config/axios';

export async function listServicos() {
  return api.get('/api/servicos');
}

export async function getServico(id) {
  return api.get(`/api/servicos/${id}`);
}

export async function createServico(data) {
  return api.post('/api/servicos', data);
}

export async function updateServico(id, data) {
  return api.put(`/api/servicos/${id}`, data);
}

export async function deleteServico(id) {
  return api.delete(`/api/servicos/${id}`);
}

export async function getServicosSchema() {
  return api.get('/api/schema/servicos');
}
